import type { DatasetImage } from "@/entities/dataset";
import type { UploadFile } from "antd";

import { downloadFile } from "@/modules/file-downloader";
import { isFileUploaded } from "@/modules/upload-file";

export const convertDatasetsImageToUploadFiles = (
  datasets?: DatasetImage[]
): UploadFile[] => {
  if (!datasets?.length) return [];

  return datasets.map(convertDatasetImageToUploadFile);
};

export const convertDatasetImageToUploadFile = (
  dataset: DatasetImage
): UploadFile => {
  const { id, name, data_path, data_download_path } = dataset;

  return {
    uid: `${id}`,
    name,
    url: data_download_path ?? data_path,
    status: "done",
  };
};

export const getDatasetImageDownloadUrl = (dataset?: DatasetImage) => {
  return dataset?.data_download_path ?? dataset?.data_path;
};

export const isDatasetImageDownloadable = (dataset?: DatasetImage): boolean => {
  return getDatasetImageDownloadUrl(dataset) ? true : false;
};

export const downloadDatasetImageFile = ({
  imageFile,
  dataset,
}: {
  imageFile?: UploadFile;
  dataset?: DatasetImage;
}) => {
  const url = getDatasetImageDownloadUrl(dataset);

  if (!imageFile || !isFileUploaded(imageFile) || !url) return;

  downloadFile({
    url,
    name: imageFile.name,
    target: "_self",
  });
};
